module.exports = __webpack_public_path__ + "img/tradicional.ac40821c.svg";